<template>
    <el-dialog title="查看仓库信息" :visible.sync="visible" append-to-body v-dialogDrag width="900px"
        :close-on-click-modal="false">
        <el-form :model="form" status-icon ref="form" label-position="right" label-width="100px">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="仓库名称" prop="WarehouseName">
                        <div class="text" :title="form.WarehouseName">
                            {{ form.WarehouseName }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="入场编号" prop="Source">
                        <div class="text" :title="form.Source">
                            {{ form.Source }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="配件名称" prop="AccessoryName">
                        <div class="text" :title="form.AccessoryName">
                            {{ form.AccessoryName }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="规格型号" prop="Specification">
                        <div class="text" :title="form.Specification">
                            {{ form.Specification }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="数量" prop="Quantity">
                        <div class="text" :title="form.Quantity">
                            {{ form.Quantity }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="单位" prop="Unit">
                        <div class="text" :title="form.Unit">
                            {{ form.Unit }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="重量" prop="Weight">
                        <div class="text" :title="form.Weight">
                            {{ form.Weight }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="配件图片" >
                        <div class="text" :title="form.Weight">
                            <UploadPhoto :uid="form.boardListPhotos"  label="配件图片"></UploadPhoto>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-button type="canale" @click="visible = false">关 闭</el-button>
        </span>
    </el-dialog>
</template>
    
<script>
export default {
    props: ["item"],
    components: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            isable: true,
            isEdit:false,
            form: {},
        };
    },
    computed: {
    },
    watch: {
        item: {
            handler: function (v) {
            if (v.WarehouseId) {
                this.isEdit = true;
                this.$get("AccessoryEntryRecords/GetModel", {
                    EntyId: v.EntyId,
                }).then((r) => {
                    this.init({ ...r.Result });
                });
            } else {
                this.init({});
                this.isEdit = false;
            }
                this.visible = true;
            },
        },
    },
    methods: {
        init(form) {
            this.form = { ...form };
            if (this.$refs["form"]) {
                this.$refs["form"].resetFields();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
    margin-top: 10px;
    @include font_color("text-color2");
}
</style>